import React from 'react'
import { hubspot } from '../../constants'
import GeneralForm from '../_shared/GeneralForm'

const ContactUs = ({ strings }) => {
  return (
    <section className="sectionPadding" id="press-contact-us">
      <GeneralForm
        title={strings.contact_us}
        description={strings.contact_us_description}
        portalId={hubspot.PORTAL_ID}
        formId={hubspot.PARTNERS_ID}
      />
    </section>
  )
}

export default ContactUs
